export default "__VITE_ASSET__DPay5xFB__"